<script lang="ts">
    import {onMount} from "svelte";
    import {AuthStore} from "../../../store/AuthStore";

    let isHide = false;

    onMount(() => {
    });

    $: appEnv = AuthStore.appEnv;

    $: isShow = (() => {
        if (isHide) {
            return false;
        }
        if ($appEnv == null) {
            return false;
        }
        if ($appEnv == 'production') {
            return false;
        }
        return true;
    })();

    function onClick() {
        isHide = true;
    }

</script>
{#if isShow}
    <div class={`app-environment-view ${$appEnv}`} on:click={onClick}>
        { $appEnv }
    </div>

{/if}

<style lang="scss">
    .app-environment-view {
        position: fixed;
        top: 0;
        left: 0;
        background-color: #000;
        color: #fff;
        padding-left: 1em;
        padding-right: 1em;
        border-radius: 10px;
        font-size: 12px;

        transition-duration: 0.5s;
        cursor: pointer;

        &.local {
            background-color: #666;
        }

        &.staging {
            background-color: #0E0EFF;
        }

        &.production {
            display: none;
        }

    }
</style>